/**
 * Returns true if the user agent is a crawler. Checks the
 * navigator.userAgent for common crawler user agents.
 */
export const isCrawler = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /(?:google|bing|msn|facebook)bot[-imagevdo]{0,6}|bingpreview|gptbot|slack(?:bot)?(?:-imgproxy|-linkexpanding)?/i.test(
    navigator.userAgent,
  );
};
